// extracted by mini-css-extract-plugin
export default {"cls1":"FuMWy2zcqvkjjumSonlO","cls2":"kk3j3jqvCqvrSoVqjgng FuMWy2zcqvkjjumSonlO"};